<template>
    <div>
        <research-list :list="list"></research-list>
    </div>
</template>
<script>
import researchList from '../../components/researchList'
export default {
    name:"equipment",
    components: { researchList },
    data(){
        return {
            list:[
                {item:11}
            ]
        }
    },
    methods(){}
}
</script>
<style lang="less" scoped>

</style>